module.exports = __webpack_public_path__ + "img/天府三中.a6eecc26.jpg";